// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f6fa178","239":"5543b50a","453":"a9d8ab9c","455":"1bb4c0cb","484":"5f2ce228","975":"affaf769"}[chunkId] + ".chunk.js";
};